let initialFields = {
  pregnancyEvent: 'No',
  placeOfDelivery: 'Health Facility',
  typeOfDelivery: 'Spontaneous Vaginal',
  assistedVaginal: 'N/A',
  periodOfGestation: 'Full term',
};

export default initialFields;
